/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateTodoRequest
 */
export interface UpdateTodoRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateTodoRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTodoRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateTodoRequest
   */
  assignee: string;
  /**
   *
   * @type {LocalDate}
   * @memberof UpdateTodoRequest
   */
  date?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof UpdateTodoRequest
   */
  deadline?: LocalDate | null;
}

/**
 * Check if a given object implements the UpdateTodoRequest interface.
 */
export function instanceOfUpdateTodoRequest(
  value: object,
): value is UpdateTodoRequest {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("assignee" in value) || value["assignee"] === undefined) return false;
  return true;
}

export function UpdateTodoRequestFromJSON(json: any): UpdateTodoRequest {
  return UpdateTodoRequestFromJSONTyped(json, false);
}

export function UpdateTodoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateTodoRequest {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    assignee: json["assignee"],
    date: json["date"] == null ? undefined : json["date"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
  };
}

export function UpdateTodoRequestToJSON(json: any): UpdateTodoRequest {
  return UpdateTodoRequestToJSONTyped(json, false);
}

export function UpdateTodoRequestToJSONTyped(
  value?: UpdateTodoRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    description: value["description"],
    assignee: value["assignee"],
    date: value["date"],
    deadline: value["deadline"],
  };
}
